<template>
	<div>
		<section class="card container grid">
		<div class="card__container grid">
			<!--==================== CARD 1 ====================-->
			<article class="card__content grid">
				<header class="card__header" style="margin-top: 20px;">
					<div class="card__header-circle grid">
					<img src="../../assets/static/images/illustrations/marketplace.svg" alt="" class="card__header-img">
					</div>
					<h1 class="card__header-title">{{ $t('instructionsText2') }}</h1>
				</header>
				<ul class="card__list grid">
					<li class="card__list-item">
						<!-- <p class="card__list-description">100 user request</p> -->
					</li>
				</ul>
				<button class="card__button login-btn" @click="goToMarketPlace()">{{ $t('marketplace') }}</button>
			</article>
			<!--==================== CARD 2 ====================-->
			<article class="card__content grid">
				<header class="card__header">
					<div class="card__header-circle grid">
						<img src="../../assets/static/images/illustrations/ecommerce.svg" style="max-width: 80%;"/>
					</div>
					<h1 class="card__header-title">{{ $t('instructionsText') }}</h1>
				</header>
				<ul class="card__list grid2">
					<li class="card__list-item">
						<font-awesome-icon class="icon" icon="check" />
						<p class="card__list-description">{{ $t('neededData1') }}</p>
					</li>
					<li class="card__list-item">
						<font-awesome-icon class="icon" icon="check" />
						<p class="card__list-description">{{ $t('neededData2') }}</p>
					</li>
					<li class="card__list-item">
						<font-awesome-icon class="icon" icon="check" />
						<p class="card__list-description">{{ $t('neededData3') }}</p>
					</li>
					<li class="card__list-item">
						<font-awesome-icon class="icon" icon="check" />
						<p class="card__list-description">{{ $t('neededData4') }}</p>
					</li>
				</ul>
				<button class="card__button"><FirstProductCreateModal/></button>
			</article>
		</div>
		</section>
	</div>
</template>

<script>
import FirstProductCreateModal from '@/components/onboarding/FirstProductCreateModal.vue'

	export default {
components: {
    FirstProductCreateModal
	},
methods: {
    goToMarketPlace() {
      this.$router.push({ name: 'marketplace' })
    }
}
}

</script>

<style lang="css" scoped>

* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

ul {
  list-style: none;
}

img {
  max-width: 100%;
  height: auto;
}

/*==================== REUSABLE CSS CLASSES ====================*/
.container {
  max-width: 1024px;
}

.grid {
  display: grid;
  justify-items: center;
}

.grid2 {
  display: grid;
  justify-items: left;
}

/*==================== CARD CONTENT ====================*/
.card {
  padding: 0;
  border: none;
}

.card__container {
  gap: 3rem 4rem;
}

.card__content {
  position: relative;
  background-color: var(--grey-light);
  padding: 2rem 1.5rem 2.5rem;
  border-radius: 1.75rem;
  transition: 0.4s;
}

.card__content:hover {
  /* box-shadow: 0 16px 24px rgb(var(--bg), 61%, 16%, 0.15); */
}

.card__header-img {
  /* width: 30px;
  height: 30px; */
}

.card__header-circle {
	max-width: 250px;
	border-radius: 50%;
	margin: auto;
	place-items: center;
}

.card__header-title {
  font-size: 1rem;
  font-weight: 700;
  }

.card__list {
  row-gap: 0rem;
  margin-bottom: 2rem;
}

.card__list-item {
  display: flex;
  align-items: center;
}
.card__list-item p {
	margin: 0px;
	padding-left: 10px;
}

.card__button {
  /* padding: 1.25rem; */
  border: none;
  font-size: var(--normal-font-size);
  border-radius: 0.5rem;
  background: linear-gradient(
    157deg,
    var(--first-color-light) -12%,
    var(--first-color) 109%
  );
  color: var(--white-color);
  cursor: pointer;
  transition: 0.4s;
}

.card__button:hover {
  box-shadow: 0 12px 24px hsla(var(--hue-color), 97%, 54%, 0.2);
}
.login-btn {
	color: var(--bright) !important;
	border: none;
	background: var(--primaryDark);
	text-decoration: none;
	text-transform: uppercase;
	font-weight: 700;
	letter-spacing: 2px;
	padding: 15px 20px;
	border-radius: 5px;
	transition: 0.3s;
	transition-property: background;
}

.login-btn:hover {
  background: var(--primary);
  color: var(--bright) !important;
}


/*==================== MEDIA QUERIES ====================*/
/* For small devices */
@media screen and (max-width: 320px) {
  .container {
    margin-left: var(--mb-1);
    margin-right: var(--mb-1);
  }
  .card__content {
    padding: 2rem 1.25rem;
    border-radius: 1rem;
  }
  .card__header-title {
  line-height: 1.4rem;
  margin-top: 1rem;
  margin-bottom: 0rem;
  }
}

@media screen and (max-width: 567px) {
  .card__header-title {
  line-height: 1.3rem;
  margin-top: 1.2rem;
  margin-bottom: 0rem;
  }
}
/* For medium devices */
@media screen and (min-width: 568px) {
  .card__container {
    grid-template-columns: repeat(2, 1fr);
  }
  .card__content {
    grid-template-rows: repeat(2, max-content);
  }
  .card__button {
    align-self: flex-end;
  }
  .card__header-title {
  line-height: 1rem;
  margin-top: 2rem;
  margin-bottom: 0rem;
    }
}

/* For large devices */
@media screen and (min-width: 968px) {
  .container {
    margin-left: auto;
    margin-right: auto;
  }
  .card {
    align-items: center;
  }
  .card__container {
    grid-template-columns: repeat(2, 1fr);
  }
  .card__header-circle {
    margin-bottom: var(--mb-1-25);
  }
  .card__header-title {
  line-height: 2rem;
  }
}

</style>